// extracted by extract-css-chunks-webpack-plugin
module.exports = {"skeleton":"skeleton__skeleton___9fB5e","skeleton-row":"skeleton__skeleton-row___3h9zf","skeletonRow":"skeleton__skeleton-row___3h9zf","skeleton-row-content":"skeleton__skeleton-row-content___38nZM","skeletonRowContent":"skeleton__skeleton-row-content___38nZM","shimmer-row":"skeleton__shimmer-row___1-iXD","shimmerRow":"skeleton__shimmer-row___1-iXD"};
    if(module.hot) {
      // 1772492733633
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  